import { projectService } from "@/service/ProjectService";
import { useNameListQuery, type NameListQueryResult } from "./useNameListQuery";

export const useProjectNames = (): NameListQueryResult =>
  useNameListQuery({
    queryKey: "projects.names",
    query: projectService.listNames,
  });

export const useFundraisingProjectNames = (): NameListQueryResult =>
  useNameListQuery({
    queryKey: "projects.fundraising-names",
    query: projectService.listFundraisingNames,
  });
